"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalStepper = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledVerticalStepper = styled_components_1.default.div `
  width: 240px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 1;
  ${props => props.theme.breakpoints.down('md')} {
    width: 180px;
  }
  ${props => props.theme.breakpoints.down('sm')} {
    display: none;
  }
`;
const VerticalStepper = props => {
    const { className, children } = props;
    return (react_1.default.createElement(StyledVerticalStepper, { className: className }, children));
};
exports.VerticalStepper = VerticalStepper;
exports.default = exports.VerticalStepper;
//# sourceMappingURL=VerticalStepper.js.map